/**
 *
 * @component 个人中心/我的方案/项目管理/协作项目详情/施工进度计划tab/验收抽屉
 *
 **/

import { useRef, useState } from 'react';
import { Drawer, Tabs } from 'antd';

import PreviewVideo from '&/components/PreviewVideo';
import PlanCheck from './PlanCheck';
import ProjectCheck from './ProjectCheck';
import ProjectCheckReport from './ProjectCheckReport.js';
import './index.scss';

function CheckReportDrawer(props) {
    const { onClose, visible, projectId, isProjectCheck, planCheckId } = props;

    const mediaSrc = useRef({
        video: '',
    });
    const tabsRef = useRef();
    const [videoVisible, setVideoVisible] = useState(false);
    const closeVideoHandler = () => {
        setVideoVisible(false);
    };

    const previewVideo = src => {
        mediaSrc.current.video = src;
        setVideoVisible(true);
    };

    const [activeKey, setActiveKey] = useState('0');

    useEffect(() => {
        if (!isProjectCheck) return;
        setActiveKey('1');
    }, [isProjectCheck]);

    const TABS_DATA = [
        {
            name: intl.get('projectSpace.projectCheck'),
            key: '0',
            component: (
                <PlanCheck
                    projectId={projectId}
                    planCheckId={planCheckId}
                    previewVideo={previewVideo}
                />
            ),
        },
        {
            name: intl.get('projectSpace.houseCheck'),
            key: '1',
            component: (
                <ProjectCheck
                    previewVideo={previewVideo}
                    projectId={projectId}
                />
            ),
        },
        {
            name: intl.get('projectSpace.houseCheckPDF'),
            key: '2',
            component: <ProjectCheckReport projectId={projectId} />,
        },
    ];

    const changeTabHandler = activeKey => {
        if (tabsRef.current && tabsRef.current.querySelector) {
            const inkBar = tabsRef.current.querySelector('.ant-tabs-ink-bar');
            if (inkBar) {
                setTimeout(() => {
                    const { length } = TABS_DATA;
                    const width = 1 / length;
                    const left = +activeKey * width;
                    const right = left + width;
                    inkBar.style.width = width * 100 + '%';
                    inkBar.style.left = left * 100 + '%';
                    inkBar.style.right = right * 100 + '%';
                }, 50);
            }
        }

        setActiveKey(activeKey);
    };

    const { TabPane } = Tabs;
    return (
        <>
            <Drawer
                width="53.75rem"
                visible={visible}
                closeIcon={<i className="icon-close filled" />}
                title={intl.get('projectSpace.explain')}
                bodyStyle={{
                    padding: '1rem',
                }}
                drawerStyle={{
                    backgroundColor: '#fbfbfd',
                    color: 'red',
                }}
                autoFocus
                destroyOnClose
                className="check-report-drawer"
                onClose={onClose}>
                <div className="drawer-body" ref={tabsRef}>
                    <Tabs
                        centered
                        activeKey={activeKey}
                        destroyInactiveTabPane
                        onChange={changeTabHandler}>
                        {TABS_DATA.map(e => (
                            <TabPane tab={e.name} key={e.key}>
                                {e.component}
                            </TabPane>
                        ))}
                    </Tabs>
                    <PreviewVideo
                        visible={videoVisible}
                        src={mediaSrc.current.video}
                        onCancel={closeVideoHandler}
                    />
                </div>
            </Drawer>
        </>
    );
}

export default CheckReportDrawer;
